import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=d87756c4&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=d87756c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87756c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d87756c4')) {
      api.createRecord('d87756c4', component.options)
    } else {
      api.reload('d87756c4', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=d87756c4&scoped=true&", function () {
      api.rerender('d87756c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2VDEA724EdJ2e/JS/comp/SearchFilterTokens.vue"
export default component.exports